import fetchSegmentDestinations from '@segment/consent-manager/esm/consent-manager-builder/fetch-destinations';
import { SEGMENT_WRITE_KEY } from 'utils/env/client';

export default async function fetchDestinations() {
  return await fetchSegmentDestinations([SEGMENT_WRITE_KEY]);
}
